import { Flex } from "@chakra-ui/react"
import CardBody from "components/Card/CardBody"

interface Props {
    children: React.ReactNode | React.ReactNode[]
}

const DataTableCard = ({ children }: Props) => {
    return (
        <CardBody px="0px">
            <Flex direction="column" w="full">
                {children}
            </Flex>
        </CardBody>
    )
}

export default DataTableCard